import { SPECIAL_ALBUM_PATH_TITLE, WEATHER_ARRAY } from '../constants'

export function pluralize (number, phrase, plural) {
  plural = plural || phrase + 's'
  return commas(number) + ' ' + (number === 1 ? phrase : plural)
}

export function commas (number) {
  if (!number && number !== 0) return ''
  return decimalPlaces(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function decimalPlaces (number, places = 2) {
  return parseFloat(parseFloat(number).toFixed(places))
}

export function isDate (string) {
  return /\d\d\d\d-\d\d-\d\d/.test(string)
}

export function isWeather (string) {
  return WEATHER_ARRAY.indexOf(string) !== -1
}

// https://gist.github.com/mathewbyrne/1280286#gistcomment-1716050
export function slug (string) {
  return string.toLowerCase()
    .replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
    .replace(/[\s_-]+/g, '-') // swap any length of whitespace, underscore, hyphen characters with a single -
    .replace(/^-+|-+$/g, '')  // remove leading, trailing -
}

export function tidyAlbumTitle (title) {
  if (SPECIAL_ALBUM_PATH_TITLE[title]) {
    return SPECIAL_ALBUM_PATH_TITLE[title]
  }
  return title.toString().replace(/^\d+\.? /, '')
}

export function getEventTitle (path, userLibraries) {
  if (userLibraries && shouldShowEventTitle(path, userLibraries) === false) {
    return ''
  }
  if (!path) {
    return 'Unknown'
  }
  const title = path.split('/').pop().replace(/^\d\d\d /, '')
  // Check if album path matches standard decade/year/season format
  const match = path.match(/^\/COLLECTIONS\/.+\/\d\d\d\ds\/(\d\d\d\d)\/\d\. ([a-z]+)/i)
  if (!match) {
    return `Unknown Year · ${title}`
  }
  const [, year, season] = match
  return `${season} ${year} · ${title}`
}

// Do not show event titles that a user does not have access to
function shouldShowEventTitle (path, userLibraries) {
  if (!path) {
    return false
  }
  const match = path.match(/^\/COLLECTIONS\/([^/]+)\//)
  if (!match) {
    return false
  }
  const library = match[1]
  return userLibraries.indexOf(library) !== -1
}

export function formatMinutes (minutes) {
  if (minutes < 1) {
    return pluralize(round(minutes * 60), 'second')
  }
  if (minutes > 60) {
    return pluralize(round(minutes / 60), 'hour')
  }
  return pluralize(round(minutes), 'minute')
}

function round (num) {
  return Math.round(num * 10) / 10
}

export function titleCase (str) {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
}

export const AND_REGEX = /( |^)and( |$)/
export const AMPERSAND_REGEX = /( |^)&( |$)/

export function matchString (needle, haystack, fuzzyAmpersands = false) {
  if (haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1) {
    return true
  }
  if (fuzzyAmpersands) {
    if (AND_REGEX.test(needle)) {
      const replaced = needle.replace(AND_REGEX, ' & ').trim()
      if (matchString(replaced, haystack)) {
        return true
      }
    }
    if (AMPERSAND_REGEX.test(needle)) {
      const replaced = needle.replace(AMPERSAND_REGEX, ' and ').trim()
      if (matchString(replaced, haystack)) {
        return true
      }
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/string.js